import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/ridgeline-plot/pages/CalculatorPage";

export const Route = createFileRoute("/ridgeline-plot")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/ridgeline-plot",
      title: m.ridge_meta_title(),
      description: m.ridge_meta_description(),
      toolName: m.ridge_tool_name(),
      faqs: [
        { q: m.ridge_faq_q1(), a: m.ridge_faq_a1() },
        { q: m.ridge_faq_q2(), a: m.ridge_faq_a2() },
        { q: m.ridge_faq_q3(), a: m.ridge_faq_a3() },
        { q: m.ridge_faq_q4(), a: m.ridge_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
